import service from "./service"

const retrieveBackgroundCheckHitResults = async (data) => {
    return service(data)
}

export default retrieveBackgroundCheckHitResults
